import { render, staticRenderFns } from "./cFooter.vue?vue&type=template&id=5564f73d&scoped=true"
import script from "./cFooter.vue?vue&type=script&lang=js"
export * from "./cFooter.vue?vue&type=script&lang=js"
import style0 from "./cFooter.vue?vue&type=style&index=0&id=5564f73d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5564f73d",
  null
  
)

export default component.exports